import { db, firebaseApp } from "../../firebase";
import { Collections } from "../collections";
import { getUid } from "../auth";
import {
	FullStudentI,
	StudentInterface,
} from "../../db/models/student/student";
import { MissingType } from "../../db/models/extra";
import firebase from "firebase/compat/app";
import "firebase/compat/functions";
import { FollowerInterface } from "../../db/models/follower";
import { getStudentCvById } from "./cv";

export const getStudent = () => {
	const uid = getUid();
	if (!uid) return Promise.reject("no uid");
	return db
		.collection(Collections.USERS)
		.doc(uid)
		.get()
		.then((doc) => {
			if (doc.exists) return doc.data();
			else return null;
		});
};

export const getStudentsByReferral = () => {
	const uid = getUid();
	if (!uid) return Promise.reject("no uid");

	return db
		.collection(Collections.USERS)
		.where("invitedBySchool", "==", uid)
		.orderBy("created", "desc")
		.limit(5)
		.get()
		.then((snapshot) => {
			let res: StudentInterface[] = [];
			snapshot.forEach((doc) => {
				res.push(doc.data() as StudentInterface);
			});
			return Promise.resolve(res);
		});
};

export const getBoundedStudents = (companyId: string, assignedStudents: string[]) => {
	const uid = getUid();
	if (!uid || !companyId) return Promise.reject("bad params");

	return db
		.collection(Collections.USERS)
		// .where("bounded", "==", true)
		// .where("invitedByCompany", "==", companyId)
		.where("id", "in", assignedStudents)
		.get()
		.then((snapshot) => {
			let res: StudentInterface[] = [];
			snapshot.forEach((doc) => {
				res.push(doc.data() as StudentInterface);
			});
			return Promise.resolve(res);
		})
		.then(async (students) => {
			const promises = students.map(async (student) => {
				return {
					profile: student,
					cv: await db
						.collection(Collections.STUDENT_CVS)
						.doc(student.id)
						.get()
						.then((doc) => {
							if (doc.exists) {
								return doc.data();
							}
							return null;
						}),
				} as FullStudentI;
			});
			return Promise.all(promises);
		});
};

export const getStudentById = (studentId: string) => {
	if (!studentId) return Promise.reject("no id");
	return db
		.collection(Collections.USERS)
		.doc(studentId)
		.get()
		.then((doc) => {
			if (doc.exists) return doc.data();
			else return null;
		});
};

export const setStudent = (info: any) => {
	const uid = getUid();
	if (!uid || !info) return Promise.reject("bad params");

	const user = {
		id: uid,
		created: firebase.firestore.FieldValue.serverTimestamp(),
		...info,
	};

	return db.collection(Collections.USERS).doc(uid).set(user, { merge: true });
};

export const getStudentListener = (observer: MissingType) => {
	const uid = getUid();
	if (!uid) return;
	return db.collection(Collections.USERS).doc(uid).onSnapshot(observer);
};

export const updateStudent = (student: Partial<StudentInterface>) => {
	const uid = getUid();
	if (!uid || !student) return Promise.reject("bad params");
	return db
		.collection(Collections.USERS)
		.doc(uid)
		.set(student, { merge: true });
};

export const getStudents = () => {
	return db
		.collection(Collections.USERS)
		.where("role", "==", "student")
		.get()
		.then((snapshot) => {
			let res: StudentInterface[] = [];
			snapshot.forEach((doc) => {
				res.push(doc.data() as StudentInterface);
			});
			return Promise.resolve(res);
		});
};

export const getStudentsByDate = (begin: Date, end: Date) => {
	return db
		.collection(Collections.USERS)
		.where("role", "==", "student")
		.where("created", ">=", begin)
		.where("created", "<=", end)
		.get()
		.then((snapshot) => {
            let students: StudentInterface[] = [];
            snapshot.forEach((doc) => {
                students.push(doc.data() as StudentInterface);
            });

            const studentsPromise = students.map(async (student) => {
                // const accountPromise = await getUserByUid(student.id);
                const cv = await getStudentCvById(student.id);
                return {
                    profile: student,
                    cv,
                };
            });
            return Promise.all(studentsPromise);
        });
};

export const getUserListenerWithUid = (uid, observer) => {
    if (!uid) return;
    return db.collection(Collections.USERS).doc(uid).onSnapshot(observer);
};

export const deleteStudent = (studentId: string) => {
	if (!studentId) return Promise.reject("Bad params");

	const callable = firebaseApp
		.functions("europe-west1")
		.httpsCallable("deleteStudent");
	return callable({ studentId });
};

export const updateStudentFollows = (studentId: string, follows: any) => {
	if (!studentId || !follows) return Promise.reject();

	return db.collection(Collections.USERS).doc(studentId).update({ follows });
};

export const isFollowing = (student: StudentInterface) => {
    if(!student) return false;

    const follows = student.follows;
    const followArray = Object.keys(follows || {});

    return followArray.length !== 0;
}

export const didGames = (student: StudentInterface) => {
    if(!student) return false;

    const games = student.games || [];

    return games.length !== 0;
}